exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer{border-top:1px solid #ddd; font-size: 14px; margin-top: 0px;}\nfooter li{padding:2px 0;}\n.footer-middle{padding:30px 0; background:#eee;}\n.footer-bottom{text-align:center; font-size: 11px; line-height:20px; background:#eee; border-top:1px solid #b50721; padding-top:15px;}\n\n\n@media (max-width: 767px) {\n    footer{margin-top: 0px;}\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/guest/footer/footer.component.css
// module id = ../../../../../src/app/guest/footer/footer.component.css
// module chunks = 39